import React from 'react';
import Image from 'next/image';
import { FaCheckCircle } from 'react-icons/fa';
import { ServiceCardProps } from '../types3';
import Button from '@/components/Button';

const ServiceCard: React.FC<ServiceCardProps> = ({
  img,
  title0,
  title1,
  title2,
  title3,
  title4,
  title5,
  description,
  items,
}) => {
  const renderItems = () => {
    if (!items || !Array.isArray(items)) return null;
    return items.map((item, index) => (
      <li key={index} className="flex items-center space-x-2 text-gray-medium mb-2">
        <FaCheckCircle className="text-green-accent mt-1" />
        <span>{item.trim()}</span>
      </li>
    ));
  };

  return (
    <div className="flex flex-col space-y-6 bg-white p-4 rounded-lg shadow-lg w-full">
      {/* Imagen */}
      {img ? (
        <div className="relative w-full aspect-video md:aspect-[4/3] mb-4 group"> 
          <Image
            src={img}
            alt={title1}
            fill 
            className="object-cover shadow-[10px_10px_0px_0px_var(--green-light)] rounded-lg image-hover-effect"
            sizes="(max-width: 768px) 100vw, 40vw"
          />
        </div>
      ):null}

      {/* Contenido */}
      <div className="w-full space-y-5 text-center relative">
        {title0 && (
 <div className="absolute top-8 right-0 transform rotate-45 bg-green-accent text-white p-4 text-xl font-bold shadow-lg transition-transform duration-300 ease-in-out hover:scale-105 hover:rotate-12">
            {title0}
          </div>
        )}
        <div className="space-y-0">

          {title1 && (
          <h2 className="text-2xl md:text-3xl font-semibold bg-blue text-white p-2 rounded-none">
              {title1}
            </h2>
          )}

          {title2 && (
            <h3 className="text-lg md:text-xl bg-blue text-white p-2 rounded-none">
              {title2}
            </h3>
          )}

          <div className="flex items-center justify-center space-x-2">
            {title3 && <h3 className="text-lg md:text-xl line-through">{title3}</h3>}
            {title4 && <h2 className="text-2xl md:text-3xl font-semibold text-green-accent">{title4}</h2>}
          </div>
          {title5 && <h3 className="text-lg md:text-xl">{title5}</h3>}
          <p className="text-gray-medium">{description}</p>
        </div>
        <ul className="list-none ml-0 mt-5">
          {renderItems()}
        </ul>
        <div className="mt-4">
          <Button title="Obtener Ahora" />
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
